import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7ced56ef&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ced56ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ced56ef')) {
      api.createRecord('7ced56ef', component.options)
    } else {
      api.reload('7ced56ef', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=7ced56ef&scoped=true", function () {
      api.rerender('7ced56ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataCenter/source/detail.vue"
export default component.exports